import React, { forwardRef, useRef, useContext } from "react";
import KeyValueDisplay from "../components/KeyVakueDisplay";
import { dateTimeFormatted } from "../../main";
import { LoadingSvg } from "../../icons/Icon";
import { Loading } from "../Loaders";
import { useEventContext } from "../../contexts/EventContextProvider";
import { PlaceholderContext } from "../../contexts/Contexts";
import { ErrorDialog } from "../modal/Dialog";
import ExpandableTokens from "../../widgets/ExpandableTokens";

const VariantTagsDisplayBar = forwardRef((p, r) => {

    const { state, eventDispatch } = useEventContext();
    const placeholder = useContext(PlaceholderContext);

    const render = (p) => {
        return (
            <div className="flex-row" ref={r}>
                <div className="col-24">
                    <div className="ListItemDetails">
                        <div className="flex-column">
                            <div className="flex-row">
                                <div className="col-24">
                                    <ExpandableTokens list={p.tags} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const renderCase = (state) => {
        switch (true) {
            case state?.state == 'LOADING':
                return <Loading><LoadingSvg /></Loading>;
            case state?.data?.id > 0 && state.visibility:
                console.log('renderCase', state.data)
                return render(state.data);
            case state?.state == 'ERROR':
                return <></>;
            default:
                return <></>;
        }
    }
    return (state?.variantTags && state.variantTags[p.id]) ? renderCase(state.variantTags[p.id]) : <></>;
});

export default VariantTagsDisplayBar;